"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseMessage = void 0;
const BaseLogger_1 = require("./BaseLogger");
class BaseMessage extends BaseLogger_1.BaseLogger {
    constructor(payload) {
        super();
        this.raw = payload;
    }
    get correlationId() {
        return this.raw.correlationId;
    }
    get payload() {
        const { correlationId: _, ...rest } = this.raw;
        return rest;
    }
    raw;
    getLogPayload() {
        return { payload: this.raw };
    }
}
exports.BaseMessage = BaseMessage;
